import { localStorageKeys } from '@src/consts';
import { api } from '@src/lib/api-client';

export const signOut = async (): Promise<void> => {
  await api.delete('api/v3/user/sign-out').finally(() => {
    const prefixes = Object.values(localStorageKeys);
    for (const key of Object.keys(localStorage)) {
      if (prefixes.some((prefix) => key.startsWith(prefix))) {
        localStorage.removeItem(key);
      }
    }
    sessionStorage.clear();
  });
};
